export function removeSelectionId(params: Params) {
  const { selectionIds, selectionId } = params;

  const remainingSelectionIds = new Set(selectionIds);

  remainingSelectionIds.delete(selectionId);

  return [...remainingSelectionIds];
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  selectionIds: string[];
  selectionId: string;
};
